import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, EventEmitter, Output, ApplicationRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { ScheduleLabelPipe } from '../../../common/pipes/schedule-label.pipe';
import { ScheduleProgrammingService } from './../../quickstart-schedule/services/schedule.service';
import { CodeItem } from '../../../common/interfaces/code-item.interface';


@Component({
  selector: 'prg-event-codeitems,[prg-event-codeitems]',
  templateUrl: './event-codeitems.component.html',
  styleUrls: ['./event-codeitems.component.less']
})
export class EventCodeitemsComponent implements OnInit {

  @Input() event: any;
  @Input() subtitle: string;
  @Input() expanded: boolean;

  @ViewChild('confirmDeleteModal') confirmDeleteModal;

  ready: Observable<boolean>;
  editing: Observable<boolean>;
  adding: Observable<boolean>;

  delete: EventEmitter<CodeItem>;

  constructor(
    private appRef: ApplicationRef,
    private store: Store<{ sharedProgramming: CommonProgrammingContext }>,
    private route: ActivatedRoute,
    private utils: Utils,
    private shared: SharedProgrammingService,
    private schedule: ScheduleProgrammingService,
    private scheduleLabel: ScheduleLabelPipe
  ) {
    this.editing = this.store.select(s => s.sharedProgramming.editing);
    this.adding = this.store.select(s => s.sharedProgramming.adding);
    this.ready = this.store.select(s => s.sharedProgramming.ready);

    this.delete = new EventEmitter<CodeItem>();
  }

  ngOnInit() {
    this.shared.clearError();
    // console.log('event-codeitems: given event', this.event);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/event-codeitems/event-codeitems.component.ts